package one.healthium.log_water.di

import one.healthium.log_water.ui.internal.LogWaterViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val waterIntakeModule = module {
    viewModelOf(::LogWaterViewModel)
}